var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hd-view',{staticClass:"tab_inner",attrs:{"patientId":_vm.patientId}})}
var staticRenderFns = []

export { render, staticRenderFns }